import React, { useEffect, useState } from "react";
import { redirect } from "react-router-dom";
import { API } from "../../../App";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Link,
} from "@mui/material";

import Paper from "@mui/material/Paper";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";

function ListCategories() {
  const [categories, setCategories] = useState([]);

  /**
   *
   * @returns
   */
  const getCategories = async () => {
    const categoriesResponse = await fetch(`${API}/api/admin/categories/list`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage["tk"]}`,
      },
    })
      .then((res) => res.json())
      .catch((err) => console.log(err));
    if (!categoriesResponse.message) {
      setCategories(categoriesResponse);
    } else {
      return redirect("/admin");
    }
  };
  /**
   *
   */
  useEffect(() => {
    getCategories();
  }, []);

  return (
    <TableContainer style={{ backgroundColor: "#010b2a" }} component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell style={{ color: "white", fontSize: "1.5rem" }}>
              Categoría
            </TableCell>
            <TableCell style={{ color: "white", fontSize: "1.5rem" }}>
              Orden
            </TableCell>
            <TableCell style={{ color: "white", fontSize: "1.5rem" }}>
              Estado
            </TableCell>
            <TableCell style={{ color: "white", fontSize: "1.5rem" }}>
              Mostrar en el home
            </TableCell>
            <TableCell
              style={{ color: "white", fontSize: "1.5rem" }}
            ></TableCell>
            <TableCell style={{ color: "white", fontSize: "1.5rem" }}>
              <Link href="/admin/panel/categories/new">
                <AddIcon color="primary" />
              </Link>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {categories.map((category) => (
            <TableRow
              key={category.id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell
                style={{ color: "white", fontSize: "1.5rem" }}
                component="th"
                scope="row"
              >
                {category.title}
              </TableCell>

              <TableCell style={{ color: "white", fontSize: "1.5rem" }}>
                {category.order}
              </TableCell>

              <TableCell style={{ color: "white", fontSize: "1.5rem" }}>
                {category.active ? "Activa" : "Inactiva"}
              </TableCell>
              <TableCell style={{ color: "white", fontSize: "1.5rem" }}>
                {category.showInHome ? "Si" : "No"}
              </TableCell>

              <TableCell style={{ color: "white", fontSize: "1.5rem" }}>
                <Link href={`/admin/panel/categories/${category.id}/edit`}>
                  <EditIcon color="primary" />
                </Link>
              </TableCell>

              <TableCell style={{ color: "white", fontSize: "1.5rem" }}>
                <DeleteIcon color="primary" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
export default ListCategories;
